export const getCurrentDate = () => {
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month < 10 ? "0" : ""}${month}-${
    day < 10 ? "0" : ""
  }${day}`;
  return currentDate;
};

export const getDateOfLast = (days) => {
  let currentDate = new Date();
  let thirtyDaysAgo = new Date(currentDate);
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - days);
  let formattedDate = thirtyDaysAgo?.toISOString().split("T")[0];
  return formattedDate;
};

export const getFirstDayOfCurrentMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}-01`;
};

export const getCurrentTime = () => {
  const date = new Date();
  let hr = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  let sec =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  // This arrangement can be altered based on how we want the date's format to appear.
  let currenTime = `T${hr}:${min}:${sec}.000Z`;
  return currenTime;
};

export const normalizeDate = (input) => {
  try {
    if (!input) return "";

    // Try parsing with Date constructor first
    let date = new Date(input);

    // If parsing failed (Invalid Date), try replacing common delimiters
    if (isNaN(date.getTime())) {
      const cleanInput = input
        .replace(/[-.]/g, "/") // Replace - and . with /
        .replace(/\s+/g, " "); // Remove extra spaces
      date = new Date(cleanInput);
    }

    // Still invalid? Try parsing manually
    if (isNaN(date.getTime())) {
      const parts = input.match(/(\d{1,4})[^\d]+(\d{1,4})[^\d]+(\d{1,4})/);
      if (parts) {
        let [_, p1, p2, p3] = parts;
        // Decide which part is year/month/day
        if (p1.length === 4) {
          // YYYY-MM-DD or YYYY-DD-MM
          date = new Date(`${p1}-${p2}-${p3}`);
        } else if (p3.length === 4) {
          // DD-MM-YYYY or MM-DD-YYYY
          date = new Date(`${p3}-${p2}-${p1}`);
        }
      }
    }

    // Final check
    if (isNaN(date.getTime())) return "";

    // Format YYYY-MM-DD
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    // console.log("Normalized date:", `${year}-${month}-${day}`);
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error normalizing date:", error);
    return "";
  }
};

export const normalizeTenDigitDate = (inputDate) => {
  try {
    if (!inputDate) return "";

    // Replace / with - for consistency
    const dateStr = inputDate.replace(/[\s./]+/g, "-").trim();

    // Split parts
    const parts = dateStr.split("-");

    let day, month, year;

    if (parts[0].length === 4) {
      // Format: YYYY-MM-DD
      [year, month, day] = parts;
    } else if (parts[2].length === 4) {
      // Assume DD-MM-YYYY
      [day, month, year] = parts;
    } else {
      throw new Error("Unrecognized date format: " + inputDate);
    }

    // Pad day and month with leading 0
    day = day.padStart(2, "0");
    month = month.padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error normalizing ten-digit date:", error);
    return "";
  }
};

// const dates = [
//   "12-02-2025",
//   "09-Jul-2025",
//   "12-January-2025",
//   "11-23-2025",
//   "2025/06/10",
//   "2025-06-10",
//   "",
//   "21-07-2025",
//   "10.06.2025",
//   "13/10/2025",
//   "2025.09.11",
//   "15 02 2025",
//   "76352563",
//   "abcd",
//   "2025-01-10T12:00:00Z",
//   "2025-11-10T12:00:00.000Z",
// ];
// Example usage of normalizeDate
// const normalizedDates = dates.map((date) => normalizeDate(date));
// console.log(normalizedDates); // Output: ['2025-06-10', '2025-07-21', '2025-06-10', '2025-06-10', '2025-06-10', '2025-06-10', '2025-06-10', '2025-06-10']

// console.log(normalizeTenDigitDate("12-02-2025")); // "2025-02-12"
// console.log(normalizeTenDigitDate("08-03-2025"));
// console.log(normalizeTenDigitDate("12.02.2025"));

export const getMonthNameOfLast = (monthsAgo) => {
  const date = new Date();
  date.setMonth(date.getMonth() - monthsAgo);
  return date.toLocaleString("default", { month: "long" });
};
